import React from 'react'
import PropTypes from 'prop-types'

export default class DeferredStyle extends React.Component {
  componentDidMount () {
    const href = this.props.href
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(() =>
        window.setTimeout(() => this.loadDeferredStyle(href), 0)
      )
    } else {
      window.addEventListener('load', () => this.loadDeferredStyle(href))
    }
  }

  loadDeferredStyle (href) {
    var deferredLink = document.createElement('link')
    deferredLink.rel = 'stylesheet'
    deferredLink.href = href
    deferredLink.type = 'text/css'
    var parentLink = document.getElementsByTagName('link')[0]
    parentLink.parentNode.insertBefore(deferredLink, parentLink)
  }

  render () {
    return (
      <noscript>
        <link href={this.props.href} rel='stylesheet' />
      </noscript>
    )
  }
}

DeferredStyle.propTypes = {
  href: PropTypes.string.isRequired
}
